import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';
import {
  QueryParamsHandling,
  RouterLink,
  RouterLinkActive,
} from '@angular/router';
import { TabMenuItemComponent } from '../tab-menu-item/tab-menu-item.component';
import { TabItem, TabMenuStyle } from '../../tab-menu.model';
import { MatRipple } from '@angular/material/core';
import { NgClass } from '@angular/common';

@Component({
  selector: 'twc-tab-menu-link-wrapper',
  imports: [
    MatRipple,
    RouterLinkActive,
    TabMenuItemComponent,
    RouterLink,
    NgClass,
  ],
  templateUrl: './tab-menu-link-wrapper.component.html',
  styleUrl: './tab-menu-link-wrapper.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TabMenuLinkWrapperComponent<T = unknown> {
  item = input.required<TabItem>();
  replaceURL = input.required<boolean>();
  menuItemArgument = input<T>();
  queryParamHandling = input.required<QueryParamsHandling | null>();
  menuStyle = input.required<TabMenuStyle>();

  itemClick = output<TabItem>();

  protected readonly TabMenuStyle = TabMenuStyle;
}
